import { Link, type ErrorComponentProps } from '@tanstack/react-router';
import { Button } from '../ui';

/** A screen that failed to load. Always in the first download, so it can show when nothing else can. */
export function RouteError({ error, reset }: ErrorComponentProps) {
  const status = typeof error === 'object' && error && 'status' in error ? Number(error.status) : 0;
  return (
    <main className="shpage">
      <header className="sh-head">
        <div>
          <span className="sh-kicker">{status === 404 ? 'Not found' : 'Something went wrong'}</span>
          <h1>{status === 404 ? 'That isn’t in your library.' : 'This screen didn’t load.'}</h1>
          <p className="track-goal">{error instanceof Error ? error.message : String(error)}</p>
        </div>
      </header>
      <div className="row-flex">
        <Button variant="primary" onClick={reset}>
          Try again
        </Button>
        <Link to="/library" className="btn btn-quiet">
          Back to your library
        </Link>
      </div>
    </main>
  );
}
